import { memo, PropsWithChildren } from 'react';
import { NavigationIcon } from '@cbhq/cds-web/icons';
import { HStack } from '@cbhq/cds-web/layout';
import { Pressable } from '@cbhq/cds-web/system';
import { TextHeadline } from '@cbhq/cds-web/typography';

import { NavItem } from ':cloud/config/navigation_DEPRECATED';

/**
 * Note: This component is the same as CDS Navigation SidebarItem except, this accepts children which CDS currently does not support.
 * based on https://github.cbhq.net/c3/assethub-frontend/blob/master/apps/www/src/components/Navigation/SidebarItemWithChild.tsx
 */

type SidebarItemWithChildProps = PropsWithChildren<{
  children?: React.ReactNode;
}> &
  NavItem;

export const SidebarItemWithChild = memo(
  ({ icon, title, onPress, collapsed, active, children }: SidebarItemWithChildProps) => {
    const color = active ? 'primary' : 'foreground';

    return (
      <Pressable
        background="primaryWash"
        borderRadius="roundedFull"
        transparentWhileInactive={!active}
        as="button"
        onPress={onPress}
        width="100%"
      >
        <HStack gap={2} spacingHorizontal={2} spacingVertical={1} alignItems="center">
          <NavigationIcon name={icon} active={active} />
          {!collapsed && (
            <HStack alignItems="center" justifyContent="space-between" width="100%">
              <TextHeadline as="h2" color={color} overflow="wrap" spacingEnd={1}>
                {title}
              </TextHeadline>
              {children}
            </HStack>
          )}
        </HStack>
      </Pressable>
    );
  },
);
